<form [formGroup]="form">
    <div class="row">
        <div class="col-4">
            <ca-form-field>
                <ca-label>{{ 'AUTOS.SIMULAR.CONDUCTOR.FECHA_NACIMIENTO' | translate }}</ca-label>
                <ca-datepicker 
                    formControlName="preg_2148" 
                    name="preg_2148">
                </ca-datepicker>
                <ca-error *ngIf="form.controls['preg_2148'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
                <ca-error *ngIf="form.controls['preg_2148'].errors?.pattern">{{'ERROR.ERROR_FORMATO_FECHA' | translate}}</ca-error>
            </ca-form-field>
       </div>
        <div class="col-4">
            <ca-form-field>
                <ca-label>{{ 'AUTOS.SIMULAR.CONDUCTOR.FECHA_CARNET' | translate }}</ca-label>
                <ca-datepicker 
                    formControlName="preg_2149" 
                    name="preg_2149">
                </ca-datepicker>
                <ca-error *ngIf="form.controls['preg_2149'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
                <ca-error *ngIf="form.controls['preg_2149'].errors?.pattern">{{'ERROR.ERROR_FORMATO_FECHA' | translate}}</ca-error>
            </ca-form-field>
        </div>
        <div class="col-4">
            <ca-form-field>
                <ca-label>{{'AUTOS.SIMULAR.CONDUCTOR.NACIONALIDAD' | translate}}</ca-label>
                <ca-select 
                    [options]="nacionalidades"
                    keyValue="descRespuesta"
                    valueField="idRespuesta"
                    formControlName="preg_2085"
                    virtualScroll></ca-select>
                <ca-error *ngIf="form.controls['preg_2085'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
            </ca-form-field>
        </div>
    </div>
</form>